/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(document.getElementById("tab-1") != null && document.getElementById("tab-1").lenth != 0){
document.getElementById("tab-1").checked = true;
}

function initThemeSlickSliders() {
  if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
    return;
  }

  if (jQuery('.banner-slider').length) {
    jQuery('.banner-slider').slick({
      speed: 500
    });
  }

  if (jQuery('.overflow').length) {
    jQuery('.overflow').slick({
      dots: true,
      autoplay: false,
      infinite: false,
      slide: 'div',
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

if (typeof jQuery !== 'undefined') {
jQuery(document).ready(function() {
  initThemeSlickSliders();

jQuery(".carousel-cell img.sec_image").click(function(){
jQuery(".carousel-cell img.sec_image").removeClass("colborder");
    jQuery(this).addClass("colborder");
  var srvalue = jQuery(this).attr("src");
  jQuery(".collection__image.image--fade-in.lazyloaded").css({"background-image":"url("+srvalue+")"})
  });

//alert(customerID);
  if (typeof customerID !== 'undefined') {
    // Now you can use the customer ID in your jQuery code
    console.log('Logged in customer ID:', customerID);

    // You can make AJAX calls or other operations using the customer ID
    $.getJSON('https://ckorewards.com/get-customer-discount-code?customerId='+customerID, function(data) {
      console.log(data.customer_id)
        // if(data.customer_id === customerID){
          var urlParams = new URLSearchParams(window.location.search);
          var discountCode = data.discount_code;
          if (discountCode != '')  {
            // Save the discount code as a session cookie
            document.cookie = `discount_code=${discountCode}; path=/`;
            // Send GET request to "/discount/[discountcode]"
            fetch(`/discount/${discountCode}`)
            .then(function() {

              // After the discount code has been applied, force the cart to update so the discount is visible instantly
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  updates: {},
                }),
              });
            })
            .catch(function(error) {
              console.error('Error:', error);
            });
          }
          else{
             console.log("No Discount");
          }
    // }
      });
  } else {
    console.log('No customer is logged in.');
  }

//getData();

// 28/11

$('#loyalty_screen_btn').on('click' , function(){
    // debugger;
var man_load = $(this).parents('.layout').find(' #previewContainer2');
console.log(man_load);
  var attribute_av = man_load.find('#previewFrame2').attr('src');
  // var rendom_load = $(this).parents('#current_plan_card_div').find('#discount_code');
  man_load.addClass('loading');
  // rendom_load.addClass('loading_ren');
setTimeout(function(){
   man_load.removeClass('loading');
  // rendom_load.removeClass('loading_ren');
}, 1000);
// if(attribute_av !== 'undefind' && attribute_av !== false){
//   man_load.addClass('loading');
// }else{
//     man_load.removeClass('loading');
// }
});


});
}

// Function to update cart in localStorage
function updateCartInLocalStorage(cart) {
  localStorage.setItem('cart', JSON.stringify(cart));
}

// Function to get cart from localStorage
function getCartFromLocalStorage() {
  return JSON.parse(localStorage.getItem('cart')) || [];
}

// Listen for product added event
document.addEventListener('product:added', function(event) {
  var variant = event.detail.variant;
  var quantity = event.detail.quantity;

  // Get current cart from localStorage
  var cart = getCartFromLocalStorage();

  // Add the new product to the cart
  cart.push({ variant, quantity });

  // Update cart in localStorage
  updateCartInLocalStorage(cart);

  // Optionally, update the UI to reflect the new cart state
  // Dispatch cart:refresh event to update the mini-cart UI
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
});

// Listen for storage events to sync cart across tabs
window.addEventListener('storage', function(event) {
  if (event.key === 'cart') {
    // Get updated cart from localStorage
    var updatedCart = getCartFromLocalStorage();

    // Update the cart UI with the new cart state
    // Your logic to update the cart UI
  }
});

// On page load, initialize cart from localStorage
window.addEventListener('load', function() {
  var cart = getCartFromLocalStorage();

  // Initialize the cart UI with the stored cart state
  // Your logic to initialize the cart UI
});

// Function to refresh the cart
function refreshCart() {
  // Dispatch cart:refresh event to update the mini-cart UI
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}

// Add event listener to the submit button
document.querySelectorAll('button[type="submit"]').forEach(button => {
  button.addEventListener('click', function(event) {
    // Prevent default form submission if necessary
    // event.preventDefault();

    // Refresh the cart when the button is clicked
    refreshCart();
  });
});

/* COLLECTION ACCORDION */
function toggleAccordion(header) {
  const item = header.parentElement;
  const accordionItems = document.querySelectorAll('.NEWCK-accordion-item');

  accordionItems.forEach((accordionItem) => {
      const content = accordionItem.querySelector('.NEWCK-accordion-content');
      const icon = accordionItem.querySelector('.NEWCK-icon');

      if (accordionItem !== item) {
          accordionItem.classList.remove('NEWCK-active');
          content.style.maxHeight = null;
          icon.textContent = '+';
      }
  });

  const content = item.querySelector('.NEWCK-accordion-content');
  const icon = header.querySelector('.NEWCK-icon');

  if (item.classList.contains('NEWCK-active')) {
      item.classList.remove('NEWCK-active');
      content.style.maxHeight = null;
      icon.textContent = '+';
  } else {
      item.classList.add('NEWCK-active');
      content.style.maxHeight = '310px'; // Set to max height here
      content.style.overflowY = 'auto'; // Add scrollbar if content exceeds
      icon.textContent = '-';
  }
}
